import axios from "axios";

const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' 
  ? "http://localhost:5001/api" 
  : (process.env.REACT_APP_API_URL || "https://api.hunarmandsindh.pk/api");
// Base URL without /api for admin endpoints
const USER_BASE_URL =
  process.env.REACT_APP_USER_API_URL ||
  "https://backend.hunarmandpunjab.org.pk";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// PDF Generation API
export const generateUserPDF = async (userId: string, adminApiKey: string) => {
  try {
    // First try to get the response without specifying responseType
    // to check if it's JSON (existing challan) or blob (new challan)
    const response = await axios.post(
      `${USER_BASE_URL}/api/admin/generate-pdf`,
      { userId },
      {
        headers: {
          "X-API-Key": "123456789",
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Scholarship Management
export const applyScholarship = async (data: any) => {
  return api.post("/scholarship/apply", data);
};

export const getScholarships = async (params?: any) => {
  return api.get("/scholarship/", { params });
};

export const getScholarshipStats = async () => {
  return api.get("/scholarship/stats");
};

export const getScholarshipById = async (id: string) => {
  return api.get(`/scholarship/${id}`);
};

export const updateScholarshipStatus = async (id: string, status: string, reason?: string) => {
  return api.put(`/scholarship/${id}/status`, { status, reason });
};

export const deleteScholarship = async (id: string) => {
  return api.delete(`/scholarship/${id}`);
};

// Authentication
export const loginAdmin = async (credentials: any) => {
  return api.post("/auth/login", credentials);
};

// Startup Applications
export const getStartupApplications = async () => {
  return api.get("/startup/");
};

// Contact Messages
export const submitContactMessage = async (data: any) => {
  return api.post("/contact/contact", data);
};

// Course Management
export const getCourses = async () => {
  return api.get("/courses/");
};

export const addCourse = async (formData: FormData) => {
  return api.post("/courses/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteCourse = async (id: string) => {
  return api.delete(`/courses/${id}`);
};

export default api;
